var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17655_24556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H0V21H21V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17655_24556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.58 10.7387C20.58 9.99416 20.5132 9.27827 20.3891 8.59094H10.5V12.6526H16.1509C15.9075 13.9651 15.1678 15.0771 14.0557 15.8217V18.4562H17.4491C19.4346 16.6283 20.58 13.9364 20.58 10.7387Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 21C13.3349 21 15.7117 20.0597 17.4489 18.4562L14.0555 15.8216C13.1154 16.4516 11.9126 16.8238 10.4999 16.8238C7.76509 16.8238 5.45036 14.9768 4.62464 12.495H1.1167V15.2154C2.84447 18.6471 6.39536 21 10.4999 21Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62472 12.495C4.41472 11.865 4.29545 11.192 4.29545 10.5C4.29545 9.80794 4.41472 9.13499 4.62472 8.50499V5.78455H1.11678C0.40572 7.20205 0 8.80571 0 10.5C0 12.1943 0.40572 13.7979 1.11678 15.2154L4.62472 12.495Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 4.17616C12.0414 4.17616 13.4255 4.70589 14.5138 5.74634L17.5254 2.73472C15.707 1.04044 13.3301 0 10.4999 0C6.39536 0 2.84447 2.35294 1.1167 5.78455L4.62464 8.505C5.45036 6.02322 7.76509 4.17616 10.4999 4.17616Z",
    fill: "#E94235"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.cf63105e8bee89027cc1a8424e6f025f.svg";
export { ForwardRef as ReactComponent };